import { IPlayManager } from '@src/slide/application/service/play-service/play-manager.interface';
import { observable } from 'mobx';
import { RegionType } from '@src/slide/domain/selection/constant/region';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { IEditorInstanceService } from '@src/slide/application/service/editor-instance-service/editor-instance-service.interface';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';

export default class PlayManager implements IPlayManager {
    @observable
    public isPlaying = false;
    @observable
    public currentSlideModel?: ISlideModel = undefined;
    public play: () => void | null | undefined;
    public endPlay: () => void | null | undefined;
    public playAction = undefined;
    public playEndAction = undefined;
    public hasShowRemotePlay = false;

    public constructor(
        selectionService: ISelectionService,
        editorInstanceService: IEditorInstanceService,
    ) {
        // window失去焦点时，  退出图片裁剪，拖拽，缩放态
        eventBus.on(EventKeys.START_PLAY, () => {
            editorInstanceService?.getEditorInstance()?.triggerBlur();
            selectionService.lastMouseDownRegion = RegionType.NONE;
        });
        eventBus.on(EventKeys.END_PLAY, () => {
            selectionService.lastMouseDownRegion = RegionType.NONE;
        });
    }
}
